module.exports = __webpack_public_path__ + "img/icon-colored-light.ac91883d.svg";